import { render, staticRenderFns } from "./PopupRemoveMeal.vue?vue&type=template&id=60276898"
import script from "./PopupRemoveMeal.vue?vue&type=script&lang=js"
export * from "./PopupRemoveMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports